import React, { useState } from "react";
import { ValidatedInput } from '../ValidatedInput.js/ValidatedInput';

import { alphanumericValidator, customRegexValidator, USER_ID_REGEX, USER_NAME_REGEX } from '../../validators/InputValidator';


export default function AdminUserInformation(props) {
    const [userIdFocus, setUserIdFocus] = useState(false);
    const [customerIdFocus, setCustomerIdFocus] = useState(false);
    const { userId, customerId, errors, setErrors, handleFieldUpdate, name } = props;

    const handleInputChange = (errorKey, inputValue, valueSetter, validator, regex) => {
        let validationError;
        if (validator) {
            validationError = validator(inputValue, regex)
        }

        valueSetter(errorKey, inputValue);

        if (validationError) {
            setErrors({ ...errors, [errorKey]: validationError });
        } else {
            setErrors(current => {
                // create copy of error state
                const copy = { ...current };
                // remove error key from object
                delete copy[errorKey];
                return copy;
            });
        }
    }

    return (
        <><div className="row">
            <div className="col">
                <ValidatedInput
                    label="Name*"
                    errorKey="name"
                    formName="userInfo"
                    maxLength={256}
                    value={name}
                    valueSetter={handleFieldUpdate}
                    validator={customRegexValidator}
                    regex={USER_NAME_REGEX}
                    onChange={handleInputChange}
                    errors={errors?.name}
                />
            </div>
            <div className="col">
                <ValidatedInput
                    label="User ID*"
                    errorKey="username"
                    formName="userInfo"
                    maxLength={256}
                    value={userId}
                    valueSetter={handleFieldUpdate}
                    validator={customRegexValidator}
                    regex={USER_ID_REGEX}
                    onChange={handleInputChange}
                    errors={errors?.username}
                    onFocus={() => setUserIdFocus(true)}

                />
                {userIdFocus && <div className="cb-form-control-feedback">
                    <i className="fa fa-warning"></i>{" "}
                    Must match Commerce Connections
                </div>}
            </div>
        </div>
        <div className="row">
            <div className="col-6">
                <ValidatedInput
                    label="Customer ID*"
                    errorKey="customerId"
                    formName="userInfo"
                    maxLength={256}
                    value={customerId}
                    valueSetter={handleFieldUpdate}
                    validator={alphanumericValidator}
                    onChange={handleInputChange}
                    errors={errors?.customerId}
                    onFocus={() => setCustomerIdFocus(true)}
                />
                {customerIdFocus && <div className="cb-form-control-feedback">
                    <i className="fa fa-warning"></i>{" "}
                    Must match Commerce Connections
                </div>}
            </div>
        </div></>
    );
}